import module from 'colaborador/module.js'
import template from './template.html'
import moment from 'moment'

export const periodicidades = [
  { id: 1, descripcion: 'SEMANAL', dias: 7 },
  { id: 5, descripcion: 'CATORCENAL', dias: 14 },
  { id: 3, descripcion: 'QUINCENAL', dias: 15 },
  { id: 4, descripcion: 'MENSUAL', dias: 30 },
]

export class ColaboradorCajaAhorroPrestamosAgregarComponent {
  idProyecto
  idColaborador
  cajasAhorros
  periodicidades = periodicidades
  data = {}

  constructor($q, ColaboradorCajaAhorros, ColaboradorCajaAhorro, ColaboradorCajaAhorroPrestamosPeriodicidad, $state) {
    this.$q = $q
    this.ColaboradorCajaAhorro = ColaboradorCajaAhorro
    this.ColaboradorCajaAhorros = ColaboradorCajaAhorros
    this.ColaboradorCajaAhorroPrestamosPeriodicidad = ColaboradorCajaAhorroPrestamosPeriodicidad
    this.$state = $state
  }

  $onInit() {
    this.promise = this.ColaboradorCajaAhorros.get(this.idProyecto, this.idColaborador)
      .then(({ data }) => (this.cajasAhorros = data))
  }

  calcularPlazo() {
    if (this.data.periodicidad === 5 || this.data.periodicidad === 3) {
      this.data.plazo = this.data.plazo == 1 && this.data.meses == 1 ? +(this.data.plazo) : +(this.data.meses * 2).toFixed(0)
      this.semanas = 2
      this.division = 2
    } else if (this.data.periodicidad === 1) {
      this.data.plazo = +(this.data.meses * 4).toFixed(0)
      this.semanas = 1
      this.division = 4
    } else {
      this.data.plazo = this.data.meses
      this.semanas = 4
      this.division = 1
    }
  }

  continuar() {
    if (this.data.periodicidad && this.data.plazo && this.data.meses && this.data.totalPrestamo && this.data.fechaInicial) {
      this.data.interes = (this.data.plazo == 1 && this.data.meses == 1) ? 0.01 : 0.02
      this.data.total = 0
      let couta = this.data.totalPrestamo * this.data.interes
      this.data.totalInteres = couta * this.data.meses
      let acumulado = 0
      let fechaInicial = moment(this.data.fechaInicial)
      couta = (this.data.plazo == 1 && this.data.meses == 1) ? couta : couta / this.division
      let total = +((this.data.totalPrestamo / this.data.plazo) + couta).toFixed(2)
      let amortizaciones = []
      let obj = {
        fechaInicial: null,
        fechaFinal: null,
        importe: 0,
        interes: 0,
        total: 0,
      }

      for (let i = 0; i < this.data.plazo; i++) {
        obj = {}
        fechaInicial = fechaInicial.add(1, 'days')
        let mes = new Date(fechaInicial.format('YYYY-MM-DD'));

        //Comparaciones, si es antes o igual al día trece entonces el corte es el día 15.
        if (fechaInicial <= mes.setDate(13)) {
          obj.fechaInicial = new Date(fechaInicial.format('YYYY-MM-DD'))
          fechaInicial = fechaInicial.date(15).add(1, "days");
          obj.fechaFinal = new Date(fechaInicial.format('YYYY-MM-DD'))
        } else if (fechaInicial < mes.setDate(28)) { //Sí es antes del día 28 el corte es el ultimo día del mes.
          fechaInicial = fechaInicial.date(16).add(1, 'days');
          obj.fechaInicial = new Date(fechaInicial.format('YYYY-MM-DD'))
          fechaInicial = fechaInicial.endOf('month').add(1, "days")
          obj.fechaFinal = new Date(fechaInicial.format('YYYY-MM-DD'))
        } else if (fechaInicial >= mes.setDate(28)) {
          fechaInicial.add(1, 'month').date(1).add(1, 'days');
          obj.fechaInicial = new Date(fechaInicial.format('YYYY-MM-DD'))
          fechaInicial = fechaInicial.date(15).add(1, "days");
          obj.fechaFinal = new Date(fechaInicial.format('YYYY-MM-DD'))
        }

        if (i === this.data.plazo - 1) {
          total = (this.data.totalPrestamo + this.data.totalInteres - acumulado)
        }
        acumulado += total
        obj.importe = total - couta
        obj.interes = couta
        obj.total = total
        this.data.total += total
        amortizaciones.push(obj)
      }

      this.data.tasaPago = this.data.interes / (this.data.plazo / this.data.meses)
      this.data.tasaMensual = this.data.interes
      this.data.tasaGlobal = this.data.meses * this.data.interes
      this.amortizaciones = amortizaciones
    }
  }

  finalizar(data) {
    if (data) {
      this.$state.go('empleado.cajaAhorro.prestamos')
    }
    this.guardando = false
  }

  guardar() {
    this.data.amortizaciones = this.amortizaciones.map(item => ({ fechaInicial: item.fechaInicial, fechaFinal: item.fechaFinal }))
    this.guardando = true
  }

  obtenerCaja() {
    this.$q.all([this.ColaboradorCajaAhorro.get(this.idProyecto, this.data.cajaAhorroId)
      .then(({ data }) => (this.data = Object.assign(this.data, data)))
      .then(() => (this.data.plazo = null)),
    this.ColaboradorCajaAhorroPrestamosPeriodicidad.get(this.idProyecto, this.idColaborador)
      .then(({ data }) => (this.data.periodicidad = data.periodicidad))
    ]).then(() => (this.carcularFecha()))
  }

  carcularFecha() {
    let date = new Date();
    let day = +date.getDate();

    switch (+this.data.periodicidad) {
      case +this.periodicidades[2].id:
        this.data.fechaInicial = (day < 14) ? new Date(date.getFullYear(), date.getMonth(), 1) : ((day < 28) ? new Date(date.getFullYear(), date.getMonth(), 16) : new Date(date.getFullYear(), date.getMonth() + 1, 1))
        break
      default:
        this.data.fechaInicial = new Date()
        break
    }
  }
}

module.component('colaboradorCajaAhorroPrestamosAgregar', {
  controller: ColaboradorCajaAhorroPrestamosAgregarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/cajaAhorro/prestamos/agregar/component.js